import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { getPosts } from "../../api/blog";
import { useAppStore } from "../../store/useAppStore";
import { t } from "../../utils/utils";
import { Pagination } from "./Pagination";
import { PostMeta } from "./PostMeta";
import "./blog.css";

export function Blog() {
  const { appLang } = useAppStore();
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Math.max(1, parseInt(searchParams.get("page"), 10) || 1);

  // { items, total, page, page_size } from the API.
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  // Each language has its own posts, so switching language starts at page 1.
  const lastLang = useRef(appLang);
  useEffect(() => {
    if (appLang !== lastLang.current) {
      lastLang.current = appLang;
      setSearchParams({}, { replace: true });
    }
  }, [appLang, setSearchParams]);

  useEffect(() => {
    let cancelled = false;

    setFailed(false);
    window.scrollTo(0, 0);

    getPosts(appLang, page)
      .then((result) => !cancelled && setData(result))
      .catch(() => !cancelled && setFailed(true));

    // Ignore a slow response if the language or page changed meanwhile.
    return () => {
      cancelled = true;
    };
  }, [appLang, page]);

  const posts = data?.items;
  const totalPages = data ? Math.ceil(data.total / data.page_size) : 0;

  return (
    <div className="blog cont1">
      <div className="head1">{t.blog}</div>

      {failed && <div className="blogMessage">{t.blogLoadError}</div>}

      {data && data.total === 0 && (
        <div className="blogMessage">{t.noPosts}</div>
      )}

      {posts && posts.length > 0 && (
        <div className="blogGrid">
          {posts.map((post) => (
            <Link to={`/blog/${post.id}`} className="blogCard" key={post.id}>
              <div className="blogThumb">
                {post.thumbnail && (
                  <img src={post.thumbnail} alt="" loading="lazy" />
                )}
              </div>

              <div className="blogCardContent">
                <PostMeta post={post} appLang={appLang} />

                <div className="blogTitle">{post.title}</div>
                <div className="blogSummary">{post.summary}</div>
                <div className="blogMore">{t.seeMore} →</div>
              </div>
            </Link>
          ))}
        </div>
      )}

      <Pagination page={page} totalPages={totalPages} />
    </div>
  );
}
